export enum AllocationViewNextActionName {
  Register = 'REGISTER',
  UliDelete = 'ULI_DELETE',
  Allocate = 'ALLOCATE',
  UliRestore = 'ULI_RESTORE',
  TruckLeft = 'TRUCK_LEFT',
  CallToDock = 'CALL_TO_DOCK',
  FinishArrivalSecurity = 'FINISH_ARRIVAL_SECURITY',
  CallToArrivalSecurity = 'CALL_TO_ARRIVAL_SECURITY',
  ArriveAtDockConfirmation = 'ARRIVE_AT_DOCK_CONFIRMATION',
  ReleaseFromDock = 'RELEASE_FROM_DOCK',
  FinishDepartureSecurity = 'FINISH_DEPARTURE_SECURITY',
  AllocationDrop = 'ALLOCATION_DROP',
  TruckRelease = 'TRUCK_RELEASE',
  PerformSealPictureControl = 'PERFORM_SEAL_PICTURE_CONTROL',
  Couple = 'COUPLE',
  Decouple = 'DECOUPLE',
  RegisterNewTruck = 'REGISTER_NEW_TRUCK',
  UliClear = 'ULI_CLEAR',
  CallToWaitingArea = 'CALL_TO_WAITING_AREA',
}

export enum AllocationViewNextCombinedActionName {
  AllocateAndCallToDock = 'ALLOCATE_AND_CALL_TO_DOCK',
  CallToWaitingAreaAndAllocate = 'CALL_TO_WAITING_AREA_AND_ALLOCATE',
}
